module.exports = __webpack_public_path__ + "img/收货地址.b0c02c9f.jpg";